import React, { useState } from 'react';
import { Grid } from '@mui/material';
import {
    Formalite,
    FormalityValidator,
} from '@europrocurement/l2d-domain/reducers/formalites/slices/formalite';
import { useDispatch } from 'react-redux';
import { todoIcon } from '@europrocurement/l2d-icons';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import { AnyAction } from '@reduxjs/toolkit';
import { useModal } from '@europrocurement/flexy-components';
import useFormalityFormHandler from '../../hooks/useFormalityFormHandler';
import CardTitle from '../../components/CardTitle';
import ActionButton from '../../components/ActionButton';
import FormalityValidatorsCard from './FormalityValidatorsCard';
import ValidatorsModal from './ValidatorsModal';
import ShowValidatorModal from './ShowValidatorModal';

type FormalityValidatorsTabProps = {
    formality: Formalite;
};

const FormalityValidatorsTab: React.FunctionComponent<FormalityValidatorsTabProps> = function (
    props,
) {
    const { selectFormality } = useFormaliteService();

    const { formality } = props;
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const { updateFormality } = useFormalityFormHandler();
    const { modalActions } = useModal();
    const dispatch = useDispatch();

    const onOpenModal = () => {
        setEditModalOpen(true);
    };
    const onCloseModal = () => {
        setEditModalOpen(false);
    };
    const onEditModal = (selectedItems: FormalityValidator[]) => {
        updateFormality(formality, { validators: selectedItems }).then(() => {
            dispatch(
                selectFormality({ id: formality.id as unknown as string }) as unknown as AnyAction,
            );
        });
    };

    const onShowItem = (validator: FormalityValidator) => {
        modalActions.call(
            <ShowValidatorModal
                formalityValidator={validator}
                onSubmit={(newValidator: FormalityValidator) => {
                    const validators = [
                        ...formality.validators
                            .filter(
                                (v) => (v.validator as unknown as number) !== validator.validator,
                            )
                            .map((v) => ({
                                ...v,
                                default: newValidator.default ? false : v.default,
                            })),
                        ...[newValidator],
                    ];

                    updateFormality(formality, { validators }).then(() => {
                        dispatch(
                            selectFormality({
                                id: formality.id as unknown as string,
                            }) as unknown as AnyAction,
                        );
                    });
                    modalActions.close();
                }}
                onCancel={() => modalActions.close()}
            />,
        );
    };

    return (
        <>
            <Grid container>
                <Grid
                    item
                    xs={12}
                    md={10}
                >
                    <CardTitle title="Liste des valideurs associées" />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={2}
                >
                    <ActionButton
                        label="Modifier la liste"
                        onClick={onOpenModal}
                        icon={todoIcon}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                >
                    <FormalityValidatorsCard
                        formality={formality}
                        onUpdateValidators={onEditModal}
                        onShowItem={onShowItem}
                    />
                </Grid>
            </Grid>
            <ValidatorsModal
                isOpen={editModalOpen}
                onModalClose={onCloseModal}
                onSubmitModal={onEditModal}
                itemsSelected={formality.validators}
            />
        </>
    );
};

export default FormalityValidatorsTab;
